import {
  Card,
  CardBody,
  CardExpandToggler,
} from "./../../../components/card/card.jsx";
import Chart from "react-apexcharts";
import React, { useState, useEffect } from "react";
import { dashboard } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { toast } from "react-toastify";

function LocationCardDetail({ location_id }) {
  const [sourceChartData, setSourceChartData] = useState([0, 0, 0, 0]);
  const [listHealth, setListHealth] = useState([]);
  const [listAlarm, setListAlarm] = useState([]);
  async function getLocation() {
    try {
      const res = await dashboard.machineHealth({ location_id });
      const data = await parserAPI(res);
      setListHealth(data);
      //console.log({ data });
    } catch (e) {
      toast.error(e.message);
    }
  }
  async function getAlarm() {
    try {
      const res = await dashboard.aletStatusCompany({ location_id });
      const data = await parserAPI(res);
      //console.log({ data });
      setListAlarm(data);
      let open = data.find((s) => s.status === "Open")?.count || 0;
      let closed = data.find((s) => s.status === "Closed")?.count || 0;
      let invalid = data.find((s) => s.status === "Invalid")?.count || 0;
      let progress = data.find((s) => s.status === "In Progress")?.count || 0;
      //console.log({ open, closed, invalid, progress });
      setSourceChartData([open, closed, invalid, progress]);
    } catch (e) {
      toast.error(e.message);
    }
  }
  useEffect(() => {
    getLocation();
    getAlarm();
  }, []);
  var themeColorRgb = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme-rgb")
    .trim();
  const chartOption = {
    colors: [
      "rgba(195, 111, 130, 1)",
      "rgba(185,186,188, 1)",
      "rgb(121,121,121)",
      "rgba(249,220,142, 1)",
    ],
    chart: { sparkline: { enabled: true } },
    stroke: { show: false },
    tooltip: {
      x: { show: false },
      y: {
        title: {
          formatter: function (seriesName) {
            return "";
          },
        },
      },
    },
  };
  return (
    <div className="row gx-4">
      <div className="col-lg-6 mb-3 mb-lg-0">
        <table className="w-100 small mb-0 text-truncate text-inverse text-opacity-60">
          <thead>
            <tr className="text-inverse text-opacity-75">
              <th className="w-50">Machine Health</th>
              <th className="w-25 text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {listHealth.map((item, index) => (
              <tr className="fw-bold" key={index}>
                <td>{item.status}</td>
                <td className="text-end">{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="col-lg-6">
        <Card>
          <CardBody className="py-2">
            <h5>Total Alarm</h5>
            <div className="d-flex align-items-center">
              <div className="w-70px">
                {sourceChartData[0] +
                  sourceChartData[1] +
                  sourceChartData[2] +
                  sourceChartData[3] ===
                0 ? (
                  <div className="empty-chart">&nbsp;</div>
                ) : (
                  <Chart
                    type="pie"
                    height="70"
                    options={chartOption}
                    series={sourceChartData}
                  />
                )}
              </div>
              <div className="flex-1 ps-2">
                <table className="w-100 small mb-0 text-inverse text-opacity-60">
                  <tbody>
                    {listAlarm.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div
                              className={"w-6px h-6px rounded-pill me-2 "}
                            ></div>
                            {item.status}
                          </div>
                        </td>
                        <td className="text-end">{item.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default LocationCardDetail;
